import React from "react";
import { Link } from "react-router-dom";
import { NavItem } from "../../config/navigation";

interface MegaMenuPanelProps {
  items: NavItem[];
  columns?: 2 | 3;
  sidebarTitle: string;
  sidebarLink: string;
  sidebarLinkLabel: string;
  sidebarLinkExternal?: boolean;
  sidebarImage: string;
}

const chunkItems = (items: NavItem[], columns: number) => {
  const size = Math.ceil(items.length / columns);
  return Array.from({ length: columns }, (_, index) =>
    items.slice(index * size, (index + 1) * size)
  ).filter((column) => column.length > 0);
};

const MegaMenuArrow: React.FC = () => (
  <>
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6.29297" y="21.4106" width="22.36" height="2.83936" transform="rotate(-40.2798 6.29297 21.4106)" fill="white" />
      <rect x="9.44922" y="7.56982" width="2.83936" height="2.83936" transform="rotate(-40.2798 9.44922 7.56982)" fill="white" />
      <rect x="13.4492" y="7.89941" width="2.83936" height="2.83936" transform="rotate(-40.2798 13.4492 7.89941)" fill="white" />
      <rect x="17.4492" y="8.23047" width="2.83936" height="2.83936" transform="rotate(-40.2798 17.4492 8.23047)" fill="white" />
      <rect x="21.1211" y="12.562" width="2.83936" height="2.83936" transform="rotate(-40.2798 21.1211 12.562)" fill="white" />
      <rect x="20.7969" y="16.5645" width="2.83936" height="2.83936" transform="rotate(-40.2798 20.7969 16.5645)" fill="white" />
      <rect x="20.4648" y="20.5664" width="2.83936" height="2.83936" transform="rotate(-40.2798 20.4648 20.5664)" fill="white" />
    </svg>
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6.29297" y="21.4106" width="22.36" height="2.83936" transform="rotate(-40.2798 6.29297 21.4106)" fill="white" />
      <rect x="9.44922" y="7.56982" width="2.83936" height="2.83936" transform="rotate(-40.2798 9.44922 7.56982)" fill="white" />
      <rect x="13.4492" y="7.89941" width="2.83936" height="2.83936" transform="rotate(-40.2798 13.4492 7.89941)" fill="white" />
      <rect x="17.4492" y="8.23047" width="2.83936" height="2.83936" transform="rotate(-40.2798 17.4492 8.23047)" fill="white" />
      <rect x="21.1211" y="12.562" width="2.83936" height="2.83936" transform="rotate(-40.2798 21.1211 12.562)" fill="white" />
      <rect x="20.7969" y="16.5645" width="2.83936" height="2.83936" transform="rotate(-40.2798 20.7969 16.5645)" fill="white" />
      <rect x="20.4648" y="20.5664" width="2.83936" height="2.83936" transform="rotate(-40.2798 20.4648 20.5664)" fill="white" />
    </svg>
  </>
);

const MegaMenuPanel: React.FC<MegaMenuPanelProps> = ({
  items,
  columns = 3,
  sidebarTitle,
  sidebarLink,
  sidebarLinkLabel,
  sidebarLinkExternal = false,
  sidebarImage,
}) => {
  const columnClass =
    columns === 3 ? "col-xl-4 col-lg-4" : "col-xl-6 col-lg-6";
  const menuColumns = chunkItems(items, columns);

  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <ul className="submenu">
      <li>
        <div className="mega_menu_wrapper">
          <div className="container-fluid p-0">
            <div className="mega_menu_wrapper_inner megamenu_widget_wrapper">
              <div className="row justify-content-lg-between">
                <div className="col-xl-8 col-lg-7">
                  <div className="mega_menu_box">
                    <div className="megamenu_widget_inner">
                      <div className="row">
                        {menuColumns.map((column, columnIndex) => (
                          <div
                            key={columnIndex}
                            className={`${columnClass} megamenu-col`}
                          >
                            <div className="megamenu_widget">
                              <ul className="icon_list unordered_list_block">
                                {column.map((item) => (
                                  <li key={item.id}>
                                    <Link to={item.link} onClick={handleClick}>
                                      <span className="icon_list_text">
                                        {item.title}
                                      </span>
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-5">
                  <div className="mega_menu_left megamenu-right-panel">
                    <div className="author_box">
                      <div className="author_image megamenu-author-image">
                        <img src={sidebarImage} alt={sidebarTitle} />
                      </div>
                      <div className="author_box_content">
                        <h3 className="text-white megamenu-author-title">
                          {sidebarTitle}
                        </h3>
                        {sidebarLinkExternal ? (
                          <a
                            className="thm-btn agency-btn megamenu-btn"
                            href={sidebarLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span className="text">{sidebarLinkLabel}</span>
                            <span className="arrow">
                              <span className="arrow-icon">
                                <MegaMenuArrow />
                              </span>
                            </span>
                          </a>
                        ) : (
                          <Link
                            className="thm-btn agency-btn megamenu-btn"
                            to={sidebarLink}
                            onClick={handleClick}
                          >
                            <span className="text">{sidebarLinkLabel}</span>
                            <span className="arrow">
                              <span className="arrow-icon">
                                <MegaMenuArrow />
                              </span>
                            </span>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default MegaMenuPanel;
